var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"interval":4000,"type":"card","height":"400px"}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"image",attrs:{"src":item.src,"alt":""}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d61cb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/image/image.vue
// module id = null
// module chunks = 